"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconButtonWrapper = exports.ContentWrapper = exports.StructureWrapper = exports.Description = exports.Title = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const oxygen_config_1 = require("@8x8/oxygen-config");
const oxygen_theme_1 = __importDefault(require("@8x8/oxygen-theme"));
const getTypography_1 = __importDefault(require("./utils/getTypography"));
const { novo } = oxygen_theme_1.default;
const containerStyle = (structureType) => (0, styled_components_1.css) `
  ${({ theme }) => {
    const { fontFamily, fontSize, fontWeight, letterSpacing, lineHeight } = (0, getTypography_1.default)({ theme, structureType });
    return `
      font-family: ${fontFamily};
      font-size: ${fontSize};
      font-weight: ${fontWeight};
      letter-spacing: ${letterSpacing};
      line-height: ${lineHeight};
    `;
}}
`;
const Title = styled_components_1.default.div.attrs(() => ({
    ...(0, oxygen_config_1.getTestAttributes)('TOAST_TITLE'),
})) `
  flex: 1;
  ${containerStyle('title')};
`;
exports.Title = Title;
Title.displayName = 'Title';
const Description = styled_components_1.default.div.attrs(() => ({
    ...(0, oxygen_config_1.getTestAttributes)('TOAST_DESCRIPTION'),
})) `
  flex: 1;
  ${containerStyle('description')};
`;
exports.Description = Description;
Description.displayName = 'Description';
const StructureWrapper = styled_components_1.default.div `
  display: flex;
  flex: 1;
  gap: ${novo.spacing03};
  ${({ theme }) => !theme.isClassic && `margin: ${theme.structureMargin} 0`};
`;
exports.StructureWrapper = StructureWrapper;
StructureWrapper.displayName = 'StructureWrapper';
const IconButtonWrapper = styled_components_1.default.div `
  margin: -2px;
`;
exports.IconButtonWrapper = IconButtonWrapper;
const ContentWrapper = styled_components_1.default.div `
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.structureMargin};
  max-height: ${({ theme }) => theme.maxHeight};
  overflow: auto;
`;
exports.ContentWrapper = ContentWrapper;
ContentWrapper.displayName = 'ContentWrapper';
